var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapesQuienesSomosBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1587,
    zoomAndPan: "magnify",
    viewBox: "0 0 1190.25 1417.499958",
    height: 1889,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "acb3d9c05c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.195312 L 1189.5 0.195312 L 1189.5 1416.804688 L 0 1416.804688 Z M 0 0.195312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5ba183b750"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.195312 L 1189.5 0.195312 L 1189.5 1416.804688 L 0 1416.804688 Z M 0 0.195312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1efa8d4ec3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 233.332031 -1406.820312 L 1752.351562 -787.332031 L 396.175781 2538.09375 L -1122.84375 1918.605469 Z M 233.332031 -1406.820312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fb4a51f4f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1733.589844 -794.980469 L -1122.84375 1918.605469 L 395.886719 2537.976562 L 1752.0625 -787.449219 L 1733.589844 -794.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "481f12d9f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1051.757812 1132.492188 L 1189.5 1132.492188 L 1189.5 1364.945312 L 1051.757812 1364.945312 Z M 1051.757812 1132.492188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "782b3adb85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1167.980469 1132.492188 C 1103.792969 1132.492188 1051.757812 1184.53125 1051.757812 1248.71875 C 1051.757812 1312.910156 1103.792969 1364.945312 1167.980469 1364.945312 C 1232.171875 1364.945312 1284.207031 1312.910156 1284.207031 1248.71875 C 1284.207031 1184.53125 1232.171875 1132.492188 1167.980469 1132.492188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af5f22b0da"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111.328125 344.800781 L 314.601562 344.800781 L 314.601562 389.664062 L 111.328125 389.664062 Z M 111.328125 344.800781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "32cd214040"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 314.601562 353.1875 L 308.292969 347.472656 L 272.136719 378.0625 L 232.820312 344.800781 L 193.507812 378.0625 L 154.191406 344.800781 L 111.726562 380.730469 L 118.035156 386.449219 L 154.191406 355.855469 L 193.507812 389.117188 L 232.820312 355.855469 L 272.136719 389.117188 Z M 314.601562 353.1875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad784f1ed5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111.328125 406.714844 L 314.601562 406.714844 L 314.601562 451.582031 L 111.328125 451.582031 Z M 111.328125 406.714844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9f5fa10bb6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 314.601562 415.101562 L 308.292969 409.386719 L 272.136719 439.976562 L 232.820312 406.714844 L 193.507812 439.976562 L 154.191406 406.714844 L 111.726562 442.644531 L 118.035156 448.363281 L 154.191406 417.773438 L 193.507812 451.03125 L 232.820312 417.773438 L 272.136719 451.03125 Z M 314.601562 415.101562 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#acb3d9c05c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.195312 L 1192.25 0.195312 L 1192.25 1427.144531 L 0 1427.144531 Z M 0 0.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.195312 L 1190 0.195312 L 1190 1417.398438 L 0 1417.398438 Z M 0 0.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.195312 L 1190 0.195312 L 1190 1417.398438 L 0 1417.398438 Z M 0 0.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5ba183b750)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1efa8d4ec3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fb4a51f4f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7bdec1",
    d: "M 224.214844 -1428.492188 L 1773.511719 -796.65625 L 404.777344 2559.558594 L -1144.519531 1927.722656 Z M 224.214844 -1428.492188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#481f12d9f5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#782b3adb85)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.750447, 0, 0, 0.750447, 1051.756568, 1132.494098)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 154.872889 -0.00254617 C 69.340537 -0.00254617 0.00165889 69.341538 0.00165889 154.873889 C 0.00165889 240.411446 69.340537 309.750324 154.872889 309.750324 C 240.410445 309.750324 309.749324 240.411446 309.749324 154.873889 C 309.749324 69.341538 240.410445 -0.00254617 154.872889 -0.00254617 ",
    stroke: "#f4b1b0",
    strokeWidth: 20,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af5f22b0da)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#32cd214040)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8d04f",
    d: "M 314.601562 344.800781 L 314.601562 389.113281 L 111.882812 389.113281 L 111.882812 344.800781 Z M 314.601562 344.800781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad784f1ed5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9f5fa10bb6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8d04f",
    d: "M 314.601562 406.714844 L 314.601562 451.027344 L 111.882812 451.027344 L 111.882812 406.714844 Z M 314.601562 406.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapesQuienesSomosBackground);
export default __webpack_public_path__ + "static/media/shapes_quienes_somos_background.b9057f8cb6b98911e5b23ce4fd99b99d.svg";
export { ForwardRef as ReactComponent };